export var httpHandlerOptions = {
    bufferBody: false,
};
//# sourceMappingURL=httpHandlerOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/storage/lib-esm/providers/httpHandlerOptions.js
// module id = null
// module chunks = 